module.exports = __webpack_public_path__ + "img/mg.83c0f264.svg";